import React from "react";
import { useSelector, useDispatch } from "react-redux";

import NotificationPopup from "./NotificationPopup";

import { hideNotification } from "../../../slices/NotificationSlice";

const GlobalNotification = () => {
    const dispatch = useDispatch();
    const { isVisible, userName, message, type, onConfirm } = useSelector((state) => state.notification);

    const handleCloseNotification = (response) => {
        dispatch(hideNotification());
    };

    return isVisible && <NotificationPopup userName={userName} message={message} type={type} onConfirm={onConfirm} onClose={handleCloseNotification} />;
};

export default GlobalNotification;
